import apiClient from './apiClient';

export interface CompanyData {
    id?: string;
    name: string;
    industry?: string;
    company_size?: string;
    country?: string;
    currency?: string;
    timezone?: string;
    supply_chain_type?: string;
    primary_products?: string[];
    product_categories?: string[];
    key_suppliers?: Array<{
        name: string;
        category: string;
        country: string;
        criticality: string;
    }>;
    warehouses?: Array<{
        name: string;
        location: string;
        type: string;
    }>;
    risk_tolerance?: string;
    sustainability_priority?: string;
    onboarding_completed?: boolean;
}

export const createCompany = async (companyData: CompanyData) => {
    try {
        const response = await apiClient.post('/company/', companyData);
        return response.data;
    } catch (error) {
        console.error('Error creating company:', error);
        throw error;
    }
};

export const updateCompany = async (companyId: string, companyData: Partial<CompanyData>): Promise<CompanyData> => {
    try {
        const response = await apiClient.put(`/company/${companyId}`, companyData);
        return response.data;
    } catch (error) {
        console.error('Error updating company:', error);
        throw error;
    }
};

export const completeOnboarding = async (companyId: string): Promise<CompanyData> => {
    try {
        const response = await apiClient.post(`/company/${companyId}/complete-onboarding`);
        // Ensure the onboarding_completed flag is set to true in the response
        return { ...response.data, onboarding_completed: true };
    } catch (error) {
        console.error('Error completing onboarding:', error);
        throw error;
    }
};

export const getCompany = async (companyId: string): Promise<CompanyData> => {
    try {
        const response = await apiClient.get(`/company/${companyId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching company:', error);
        throw error;
    }
};
